<template>
 <div class="recent-visits">
 <div class="chart-card">
 <div class="chart-header">
 <el-date-picker
 v-model="dateRange"
 type="daterange"
 range-separator="至"
 start-placeholder="开始日期"
 end-placeholder="结束日期"
 value-format="yyyy-MM-dd"
 :picker-options="pickerOptions"
 @change="loadAll"
 />
 <el-button type="primary" size="small" @click="loadAll" style="margin-left:12px">刷新</el-button>
 <el-pagination
 @current-change="handlePageChange"
 :current-page="page"
 :page-size="pageSize"
 :total="total"
 layout="total, prev, pager, next"
 style="float:right"
 />
 </div>
 <div class="filter-bar-inner">
 <el-input v-model="filters.ip_keyword" placeholder="搜索IP" size="small" clearable style="width:150px" @keyup.enter.native="searchData" @clear="searchData" />
 <el-input v-model="filters.location_keyword" placeholder="搜索归属地" size="small" clearable style="width:150px" @keyup.enter.native="searchData" @clear="searchData" />
 <el-input v-model="filters.referer_keyword" placeholder="搜索来源链接" size="small" clearable style="width:180px" @keyup.enter.native="searchData" @clear="searchData" />
 <el-select v-model="filters.browser_filter" placeholder="浏览器" size="small" clearable style="width:130px">
 <el-option v-for="b in filterOptions.browsers" :key="b" :label="b" :value="b" />
 </el-select>
 <el-select v-model="filters.os_filter" placeholder="操作系统" size="small" clearable style="width:130px">
 <el-option v-for="o in filterOptions.oses" :key="o" :label="o" :value="o" />
 </el-select>
 <el-select v-model="filters.device_filter" placeholder="设备" size="small" clearable style="width:110px">
 <el-option v-for="d in filterOptions.devices" :key="d" :label="d" :value="d" />
 </el-select>
 <el-select v-model="filters.visitor_type" placeholder="访客类型" size="small" clearable style="width:120px">
 <el-option label="新访客" value="new" />
 <el-option label="回访" value="returning" />
 </el-select>
 <el-button type="primary" size="small" @click="searchData">筛选</el-button>
 <el-button size="small" @click="resetFilters">重置</el-button>
 </div>
 <el-table :data="list" stripe size="small" style="width:100%" v-loading="loading">
 <el-table-column type="index" label="#" width="50" />
 <el-table-column label="IP地址" width="160">
          <template slot-scope="{ row }">
            {{ row.ip }}
            <el-tag v-if="blockedIps.has(row.ip)" size="mini" type="danger" effect="dark" style="margin-left:4px">已禁用</el-tag>
          </template>
        </el-table-column>
 <el-table-column prop="ip_location" label="归属地" width="150" />
 <el-table-column prop="website_name" label="网站" width="120" />
 <el-table-column prop="browser" label="浏览器" width="90" />
 <el-table-column prop="os" label="系统" width="90" />
 <el-table-column prop="device" label="设备" width="70" />
 <el-table-column prop="referer" label="来源链接" min-width="220">
 <template slot-scope="{row}">
 <a v-if="row.referer" :href="row.referer" target="_blank" :title="row.referer" class="referer-link">{{ row.referer }}</a>
 <span v-else style="color:#C0C4CC">直接访问</span>
 </template>
 </el-table-column>
 <el-table-column label="访客类型" width="80">
 <template slot-scope="{row}">
 <el-tag :type="row.is_new_visitor ? 'success' : 'info'" size="mini" effect="light">
 {{ row.is_new_visitor ? '新访客' : '回访' }}
 </el-tag>
 </template>
 </el-table-column>
 <el-table-column prop="page_url" label="访问页面" min-width="200">
 <template slot-scope="{row}">
 <a v-if="row.page_url" :href="row.page_url" target="_blank" :title="row.page_url" class="page-link">{{ row.page_url }}</a>
 </template>
 </el-table-column>
 <el-table-column prop="created_at" label="访问时间" width="160">
 <template slot-scope="{row}">{{ formatTime(row.created_at) }}</template>
 </el-table-column>
 </el-table>
 </div>
 </div>
</template>

<script>
import { statsApi } from '../api';
import dayjs from 'dayjs';

export default {
 name: 'RecentVisits',
 data() {
 return {
 dateRange: [dayjs().subtract(30, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')],
 list: [],
 page: 1,
 pageSize: 20,
 total: 0,
 loading: false,
 blockedIps: new Set(),
 filters: { ip_keyword: '', location_keyword: '', browser_filter: '', os_filter: '', device_filter: '', referer_keyword: '', visitor_type: '' },
 filterOptions: { browsers: [], oses: [], devices: [] },
 pickerOptions: {
 shortcuts: [
 { text: '今天', onClick(picker) { const d = dayjs().format('YYYY-MM-DD'); picker.$emit('pick', [d, d]); } },
 { text: '近7天', onClick(picker) { picker.$emit('pick', [dayjs().subtract(6, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]); } },
 { text: '近30天', onClick(picker) { picker.$emit('pick', [dayjs().subtract(29, 'day').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]); } },
 { text: '本月', onClick(picker) { picker.$emit('pick', [dayjs().startOf('month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]); } },
 ]
 }
 };
 },
 mounted() {
 this.loadBlockedIps();
 this.loadAll();
 },
 methods: {
 async loadBlockedIps() {
 try {
 const res = await statsApi.getBlockedIps();
 if (res.code === 0) this.blockedIps = new Set(res.data || []);
 } catch (e) { console.error(e); }
 },
 loadAll() {
 const [startDate, endDate] = this.dateRange || [];
 const params = { start_date: startDate, end_date: endDate };
 this.loadFilterOptions(params);
 this.page = 1;
 this.loadData(params);
 },
 async loadData(params) {
 this.loading = true;
 try {
 const res = await statsApi.recent({ ...params, ...this.filters, page: this.page, page_size: this.pageSize });
 if (res.code === 0) { this.list = res.data.list; this.total = res.data.total; }
 } catch (e) { console.error(e); }
 finally { this.loading = false; }
 },
 async loadFilterOptions(params) {
 try {
 const res = await statsApi.device(params);
 if (res.code !== 0) return;
 this.filterOptions.browsers = res.data.browsers.map(b => b.browser).filter(Boolean);
 this.filterOptions.oses = res.data.oses.map(o => o.os).filter(Boolean);
 this.filterOptions.devices = res.data.devices.map(d => d.device).filter(Boolean);
 } catch (e) { console.error(e); }
 },
 searchData() {
 this.page = 1;
 const [startDate, endDate] = this.dateRange || [];
 this.loadData({ start_date: startDate, end_date: endDate });
 },
 resetFilters() {
 this.filters = { ip_keyword: '', location_keyword: '', browser_filter: '', os_filter: '', device_filter: '', referer_keyword: '', visitor_type: '' };
 this.page = 1;
 const [startDate, endDate] = this.dateRange || [];
 this.loadData({ start_date: startDate, end_date: endDate });
 },
 handlePageChange(p) {
 this.page = p;
 const [startDate, endDate] = this.dateRange || [];
 this.loadData({ start_date: startDate, end_date: endDate });
 },
 formatTime(t) {
 return t ? dayjs(t).format('YYYY-MM-DD HH:mm:ss') : '-';
 }
 }
};
</script>

<style scoped>
.filter-bar { display: flex; align-items: center; margin-bottom: 18px; }

.chart-card { background: #fff; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.04); border: 1px solid #eef0f3; overflow: hidden; }
.chart-header { padding: 14px 20px; border-bottom: 1px solid #f0f1f3; display: flex; align-items: center; justify-content: space-between; }
.chart-title { font-size: 14px; font-weight: 600; color: #1e293b; }

.filter-bar-inner { display: flex; align-items: center; gap: 8px; padding: 12px 16px; border-bottom: 1px solid #f0f1f3; flex-wrap: wrap; background: #fafbfc; }

.referer-link, .page-link { color: #5b8def; text-decoration: none; word-break: break-all; display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; transition: color 0.2s; }
.referer-link:hover, .page-link:hover { color: #3b6fd6; text-decoration: underline; }
</style>